import {
    type UpdateSystemLocaleResponseType,
    type UpdateSystemLocaleRequestType
} from "./type";
import {
    request
} from "../request";

const updateSystemLocale = async (params: UpdateSystemLocaleRequestType): Promise<UpdateSystemLocaleResponseType> => {
    return await request<UpdateSystemLocaleResponseType>("/systemLocale/updateSystemLocale", {
        body: JSON.stringify(params),
        method: "POST"
    });
};
export default updateSystemLocale;
